import Auth from 'app/scripts/db/auth.coffee';
import { clientVersion } from '@trello/config';

export async function memberTokenIsCurrent(): Promise<boolean> | never {
  if (!Auth.isLoggedIn()) {
    return true;
  }

  const response: Response = await fetch(`/1/members/me`, {
    headers: {
      'X-Trello-Client-Version': clientVersion,
    },
  });
  if (response.ok) {
    return true;
  }

  if ([400, 401].includes(response.status)) {
    return false;
  }

  throw new Error(
    `Could not check member token status. (status: ${response.status}, statusText: ${response.statusText})`,
  );
}
